import { accessAtLeastManager } from 'charts/common/access';
import { InspectionTranslationKeys } from 'intl/keys';
import { useGetChart } from 'charts/common/hooks';
import { useMemo } from 'react';
import {
  ChartType,
  InspectionChart,
  InspectionTripletFilters,
  TripletSeriesWithLabels,
} from 'shared/types/analytics';
import type { ChartRuntime } from 'views/analytics/types';
import { useInspectionTripletFilters } from './filters';
import { mapTripletSeries } from 'charts/model/mapSeriesToRawData';

const EMPTY_TRIPLET: TripletSeriesWithLabels = [
  [{ value: undefined }, { value: undefined }, { value: undefined }],
  ['', '', ''],
];

export function useInspectionTriplet(): ChartRuntime<InspectionTripletFilters> {
  const filters = useInspectionTripletFilters();
  const { series, loading, load, reload, updatedAt } =
    useGetChart({ chart: InspectionChart.inspectionTriplet, filters, initialSeries: EMPTY_TRIPLET });

  const rawData = useMemo(() => mapTripletSeries(series), [series]);

  return {
    filters,
    titleId: InspectionTranslationKeys.summaryChart,
    chartType: ChartType.triplet,
    canAccess: accessAtLeastManager,
    loading: !filters || loading,
    load,
    forceUpdate: reload,
    updatedAt: (): number => updatedAt,
    rawData,
  };
}
